"use client";

import React, { FunctionComponent, useEffect, useState } from "react";
import Link from "next/link";
import Image from "next/image";

import { Squash as Hamburger } from "hamburger-react";

import { INavigationFields } from "@/types/generated/contentful";
import NavItem from "./navItem";
import MobileNavItem from "./mobileNavItem";

type Props = {
  content: INavigationFields | undefined;
};

const Header: FunctionComponent<Props> = ({ content }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [selectedItem, setSelectedItem] = useState<number | undefined>(
    undefined,
  );

  useEffect(() => {
    if (isOpen) {
      document.body.classList.add("overflow-hidden");
      document.body.classList.add("md:overflow-auto");
      document.body.classList.add("fixed");
      document.body.classList.add("md:static");
    } else {
      document.body.classList.remove("overflow-hidden");
      document.body.classList.remove("md:overflow-auto");
      document.body.classList.remove("fixed");
      document.body.classList.remove("md:static");
    }
    return () => {
      document.body.classList.remove("overflow-hidden");
      document.body.classList.remove("md:overflow-auto");
      document.body.classList.remove("fixed");
      document.body.classList.remove("md:static");
    };
  }, [isOpen]);

  return (
    <nav className="z-100 sticky left-0 top-0 w-full border-b border-gray-200 bg-white p-4 lg:py-0">
      <div className="mx-auto flex items-center justify-between xl:container">
        {/* Logo */}
        <span className="sr-only">SponsorPulse</span>
        <Link href="/" tabIndex={0}>
          <Image
            src="/sponsorpulse-logo.svg"
            alt="SponsorPulse"
            width={243}
            height={44}
            priority={true}
            unoptimized={true}
          />
        </Link>

        {/* Desktop Nav */}
        <ul className="hidden space-x-6 lg:flex lg:items-center">
          {content &&
            content.items.map((item, index) => (
              <NavItem
                key={index}
                item={item}
                expanded={selectedItem === index}
                itemSelected={() => setSelectedItem(index)}
                closeNav={() => setIsOpen(false)}
              />
            ))}
        </ul>

        {/* Mobile Menu Button */}
        <div className="z-100 lg:hidden">
          <Hamburger
            hideOutline={false}
            size={24}
            toggled={isOpen}
            toggle={setIsOpen}
            label="Menu"
          />
        </div>
      </div>

      {/* Mobile Drawer */}
      <div
        className={`z-100 fixed right-0 top-0 mt-20 h-full w-full transform overflow-y-auto overscroll-contain bg-white pb-20 shadow-lg transition-transform duration-300 ease-in-out md:w-3/4 lg:hidden ${
          isOpen ? "translate-x-0" : "translate-x-full"
        }`}
      >
        <div className="p-4">
          <ul className="flex flex-col space-y-4">
            {content &&
              content.items.map((item, index) => (
                <MobileNavItem
                  key={index}
                  item={item}
                  expanded={selectedItem === index}
                  itemSelected={() => setSelectedItem(index)}
                  closeNav={() => setIsOpen(false)}
                />
              ))}
          </ul>
        </div>
      </div>
    </nav>
  );
};

export default Header;
